const route = [
  {
    path: "/material/:tenant",
    name: "material",
    component: () =>
      import(/* webpackChunkName: 'material' */ "@/views/material"),
    meta: { routeName: "知识库", unGetUser: true, keepAlive: true },
  },
  {
    path: "/s/group/:tenant",
    name: "workMaterial",
    component: () =>
      import(
        /* webpackChunkName: 'workMaterial' */ "@/views/material/workMaterial"
      ),
    meta: { routeName: "知识库", unGetUser: true, keepAlive: true },
  },
  {
    path: "/searchMaterial",
    name: "searchMaterial",
    component: () =>
      import(
        /* webpackChunkName: 'searchMaterial' */ "@/views/material/search"
      ),
    meta: { routeName: "搜索", unGetUser: true },
  },
  {
    path: "/message",
    name: "message",
    component: () =>
      import(/* webpackChunkName: 'message' */ "@/views/material/message"),
    meta: { routeName: "消息订阅", unGetUser: true },
  },
  {
    path: "/s/file",
    name: "materialPreview",
    component: () =>
      import(
        /* webpackChunkName: 'materialPreview' */ "@/views/material/preview"
      ),
    meta: { routeName: "", unGetUser: true },
  },
];
export default route;
